import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTheme } from '@/contexts/ThemeContext'

/** Frame for pages anyone can open without logging in: logo bar, theme toggle and a centred column. */
export function PublicPageShell({
  children,
  wide = false,
}: {
  children: ReactNode
  /** A wider column, for content such as ads that must not be squeezed. */
  wide?: boolean
}) {
  const { t } = useTranslation()
  const { theme, toggleTheme } = useTheme()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b">
        <div
          className={`mx-auto flex ${wide ? 'max-w-6xl' : 'max-w-3xl'} items-center justify-between px-4 py-3`}
        >
          <div className="flex items-center gap-2 text-sm font-semibold tracking-widest">
            <img src="/logo.svg" alt="" className="size-6" />
            <span>ADNUNTIUS</span>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            title={theme === 'dark' ? t('login.switchToLight') : t('login.switchToDark')}
          >
            {theme === 'dark' ? <Sun /> : <Moon />}
          </Button>
        </div>
      </header>
      <main className={`mx-auto ${wide ? 'max-w-6xl' : 'max-w-3xl'} px-4 py-8`}>{children}</main>
    </div>
  )
}
